module.exports = __webpack_public_path__ + "static/media/wmv.9108d901.png";